"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.childrenPropsSDKFactory = void 0;
const childrenPropsSDKFactory = ({ getChildren }) => {
    return {
        get children() {
            return getChildren();
        },
    };
};
exports.childrenPropsSDKFactory = childrenPropsSDKFactory;
//# sourceMappingURL=childrenPropsSDKFactory.js.map